import { render, staticRenderFns } from "./AboutEnnetixContent.vue?vue&type=template&id=5e394618&scoped=true&"
var script = {}
import style0 from "./AboutEnnetixContent.vue?vue&type=style&index=0&id=5e394618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e394618",
  null
  
)

export default component.exports